import { nsform } from "../../../../i18n/namespaces";
import React from 'react';
import { useTranslation } from 'react-i18next';
export const TextareaCounter = props => {
  const {
    counter,
    count,
    limit
  } = props;
  const {
    t
  } = useTranslation(nsform.common);
  if (counter && !limit) return /*#__PURE__*/React.createElement(React.Fragment, null, count, " ", t('textarea.counter.character'));
  if (!counter && limit) return /*#__PURE__*/React.createElement(React.Fragment, null, limit, " ", t('textarea.counter.maxCharacter'));
  if (counter && limit) return /*#__PURE__*/React.createElement(React.Fragment, null, t('textarea.counter.available'), " ", limit - count, " ", t('textarea.counter.limitChar'), " ", limit);
  return /*#__PURE__*/React.createElement(React.Fragment, null);
};